const questions = [
  // ---------- SINGLE ANSWER ----------
  {
    type: "single",
    question: "What does HTML stand for?",
    options: [
      "Hyper Text Markup Language",
      "High Text Machine Language",
      "Hyperlinks and Text Markup Language",
      "Home Tool Markup Language"
    ],
    answer: [0]
  },
  {
    type: "single",
    question: "Which hook is used to manage state in React?",
    options: ["useRef", "useEffect", "useState", "useMemo"],
    answer: [2]
  },
  {
    type: "single",
    question: "Which CSS property controls text size?",
    options: ["font-style", "text-size", "font-size", "text-weight"],
    answer: [2]
  },
  {
    type: "single",
    question: "Which keyword declares a constant in JavaScript?",
    options: ["let", "var", "const", "static"],
    answer: [2]
  },
  {
    type: "single",
    question: "What does DOM stand for?",
    options: [
      "Document Object Model",
      "Data Object Method",
      "Digital Output Model",
      "Document Orientation Model"
    ],
    answer: [0]
  },

  // ---------- MULTIPLE ANSWER ----------
  {
    type: "multi",
    question: "Which of the following are JavaScript frameworks?",
    options: ["React", "Django", "Vue", "Laravel"],
    answer: [0, 2]
  },
  {
    type: "multi",
    question: "Which are valid CSS units?",
    options: ["px", "em", "kg", "vh"],
    answer: [0, 1, 3]
  },
  {
    type: "multi",
    question: "Which are frontend technologies?",
    options: ["HTML", "CSS", "Node.js", "JavaScript"],
    answer: [0, 1, 3]
  },
  {
    type: "multi",
    question: "Which methods are array methods in JavaScript?",
    options: ["map()", "filter()", "query()", "reduce()"],
    answer: [0, 1, 3]
  },
  {
    type: "multi",
    question: "Which are React hooks?",
    options: ["useState", "useEffect", "useClass", "useRef"],
    answer: [0, 1, 3]
  },

  // ---------- FILL IN THE BLANK ----------
  {
    type: "text",
    question: "CSS stands for ______ Style Sheets.",
    answer: ["cascading"]
  },
  {
    type: "text",
    question: "JavaScript was originally developed by ______.",
    answer: ["netscape"]
  },
  {
    type: "text",
    question: "React is maintained by ______.",
    answer: ["meta", "facebook"]
  },
  {
    type: "text",
    question: "The HTML tag used for JavaScript is ______.",
    answer: ["script"]
  },
  {
    type: "text",
    question: "______ is used to style web pages.",
    answer: ["css"]
  },

  // ---------- MIXED / EXTRA ----------
  {
    type: "single",
    question: "Which symbol is used for comments in JavaScript?",
    options: ["//", "/* */", "#", "<!-- -->"],
    answer: [0]
  },
  {
    type: "multi",
    question: "Which are version control systems?",
    options: ["Git", "GitHub", "Docker", "SVN"],
    answer: [0, 1, 3]
  },
  {
    type: "text",
    question: "______ is the command to create a new React app.",
    answer: ["create-react-app"]
  },
  {
    type: "single",
    question: "Which HTML tag is used for images?",
    options: ["<image>", "<img>", "<src>", "<pic>"],
    answer: [1]
  },
  {
    type: "multi",
    question: "Which are valid HTTP methods?",
    options: ["GET", "POST", "FETCH", "DELETE"],
    answer: [0, 1, 3]
  }
];

export default questions;
